const FLAG_LABELS = {
  "US": "美国",
  "GB": "英国",
  "CA": "加拿大",
  "CH": "瑞士",
  "MX": "墨西哥",
  "ZH": "ZH",
  "AU": "澳大利亚",
  "NZ": "新西兰",
  "IT": "義大利",
  "FR": "法國",
  "DE": "德國",
  "ES": "西班牙",
  "JP": "日本",
  "KR": "韓國",
};

const COUNTRIES = ["US", "GB", "CA", "CH", "MX", "AU", "NZ", "IT", "FR", "DE", "ES", "JP", "KR"];

export { FLAG_LABELS, COUNTRIES };


// WEBPACK FOOTER //
// ./src/constants/country.js